import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowBack = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M26.1778 10.8228C25.427 10.1066 24.2167 10.1066 23.4659 10.8228L10.7338 22.9694C10.1363 23.5395 10.1363 24.4604 10.7338 25.0304L23.4659 37.177C24.2167 37.8933 25.427 37.8933 26.1778 37.177C26.9285 36.4608 26.9285 35.3061 26.1778 34.5899L15.0851 23.9926L26.1931 13.3954C26.9285 12.6938 26.9285 11.5244 26.1778 10.8228Z",
		fill: "white"
	})
});
export default SvgArrowBack;
